"use client";

/** 複数行の入力欄。ラベルと補足と文字数を添える */
export default function TextAreaField({
  id,
  label,
  value,
  onChange,
  note,
  noteAbove,
  rows = 4,
  max,
  disabled,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  note?: string;
  /** 補足を枠の上（ラベルの下）に置く */
  noteAbove?: boolean;
  rows?: number;
  max?: number;
  disabled?: boolean;
}) {
  return (
    <div className="field">
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      {note && noteAbove ? <p className="field-note field-note-above">{note}</p> : null}
      <textarea
        id={id}
        className="field-input field-textarea"
        rows={rows}
        value={value}
        maxLength={max}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
      {(note && !noteAbove) || max ? (
        <p className="field-note">
          {noteAbove ? null : note}
          {max ? <span className="field-count">{value.length} / {max}</span> : null}
        </p>
      ) : null}
    </div>
  );
}
